import { TFunction } from 'i18next';

export const normalizeAstroKey = (value: string) => String(value || '').trim().toUpperCase();

export const getPlanetAbbr = (t: TFunction, value: string) => {
  const key = normalizeAstroKey(value);
  return t(`astrology.planetAbbr.${key}`, {
    defaultValue: key ? `${key.charAt(0)}${key.charAt(1)?.toLowerCase() || ''}` : '',
  });
};

export const getSignAbbr = (t: TFunction, signNumber: number | string) => (
  t(`astrology.signAbbr.${signNumber}`, { defaultValue: String(signNumber) })
);

export const getHouseShort = (t: TFunction, number: number | string) => (
  t('astrology.houseShort', { number })
);

export const getActualHouseShort = (t: TFunction, number: number | string) => (
  t('astrology.actualHouseShort', { number })
);
